import type { ToggleButtonDesignTokens } from '@primeuix/themes/types/togglebutton';

export const toggleButtonPreset: ToggleButtonDesignTokens = {
  root: {
    borderRadius: '{content.border.radius}',
    disabledBackground: 'transparent',
    disabledBorderColor: 'transparent',
    disabledColor: '{surface.500}',
    invalidBorderColor: '{nspCrimson.400}',
    focusRing: {
      color: '{nspSky.300}',
      shadow: 'none',
      offset: '0',
    },
  },
  content: {
    checkedShadow: 'none',
  },
  colorScheme: {
    dark: {
      root: {
        background: '{nspSlate.800}',
        checkedBackground: '{nspSlate.800}',
        hoverBackground: '{nspSlate.800}',
        borderColor: '{nspSlate.800}',
        color: '{nspSlate.50}',
        hoverColor: '{nspSlate.0}',
        checkedColor: '{nspSlate.0}',
        checkedBorderColor: '{nspSlate.800}',
      },
      content: {
        checkedBackground: '{nspSky.500}',
      },
      icon: {
        color: '{nspSlate.200}',
        hoverColor: '{nspSlate.0}',
        checkedColor: '{nspSlate.0}',
      },
    },
    light: {
      root: {
        background: '{nspSlate.50}',
        checkedBackground: '{nspSlate.50}',
        hoverBackground: '{nspSlate.50}',
        borderColor: '{nspSlate.50}',
        color: '{nspSlate.300}',
        hoverColor: '{nspSlate.100}',
        checkedColor: '{nspSlate.0}',
        checkedBorderColor: '{nspSlate.50}',
      },
      content: {
        checkedBackground: '{nspSky.500}',
      },
      icon: {
        color: '{nspSlate.500}',
        hoverColor: '{nspSlate.700}',
        checkedColor: '{nspSlate.900}',
      },
    },
  },
};
